export const tailwindColors = {
	'elanco-beige': {DEFAULT: '#D5C4AF'},
	'elanco-blue': {DEFAULT: '#0072CE', a: '#000'},
	'elanco-grey': {DEFAULT: '#7F7F7F'},
	'light-blue': {DEFAULT: '#D9EAF8'},
	'mid-beige': {DEFAULT: '#EEE8DF'},
	'midnight-blue': {DEFAULT: '#001149'},
	salmonella_360: {DEFAULT: '#EE7D00'},
	zenrelia_primary: {DEFAULT: '#215447'},
	zenrelia_secondary: {DEFAULT: '#91CC12'},
	zenrelia_contrast: {DEFAULT: '#A68CFA'},
	zenrelia_accent: {DEFAULT: '#c0d29a'},
	zenrelia_sku1: {DEFAULT: '#618582'},
	zenrelia_sku2: {DEFAULT: '#8752C7'},
	zenrelia_sku3: {DEFAULT: '#00A99E'},
	zenrelia_sku4: {DEFAULT: '#C6B5FF'},
	claro_neptra: {DEFAULT: '#522873'},
	advocate_orange: {DEFAULT: '#E57200'},
	gallipro_fit_yellow: {DEFAULT: '#FBBA00'},
	gallipro_fit_orange: {DEFAULT: '#EF7900'},
	gallipro_fit_green: {DEFAULT: '#9EB184'},
	gallipro_fit_darkblue: {DEFAULT: '#142C46'},
	neptra_green: {DEFAULT: '#c7d530'},
	seresto: {DEFAULT: '#00597c'},
	clik_light_blue: {DEFAULT: '#0C78BD'},
	clik_dark_blue: {DEFAULT: '#1F3560'},
	clik_yellow: {DEFAULT: '#DB9300'},
	tracer: {DEFAULT: '#ed037c'},
	bovaer: {DEFAULT: '#027d50'},
	pradalex: {DEFAULT: '#26d07c'},
	avipro_grey: {DEFAULT: '#929292'},
	avipro_red: {DEFAULT: '#d51317'},
	aviblue_light_blue: {DEFAULT: '#41c0f0'},
	aviblue_mid_blue: {DEFAULT: '#0078BF'},
	aviblue_dark_blue: {DEFAULT: '#073F65'},
	coliprotec_teal: {DEFAULT: '#0081a3'},
	flubenvet: {DEFAULT: '#788e1d'},
	hemicell_red: {DEFAULT: '#b32b2e'},
	htsi: {DEFAULT: '#004268'},
	maxiban_: {DEFAULT: '#d31245'},
	galliprant_yellow: {DEFAULT: '#ffc600'},
	galliprant_red: {DEFAULT: '#d11947'},
	bexacat_dark_grey: {DEFAULT: '#262626'},
	varenzin_blue: {DEFAULT: '#0056b8'},
	varenzin_purple: {DEFAULT: '#6a488e'},
	nuplura_ph_plus_5_primary: {DEFAULT: '#a1d060'},
	nuplura_ph_plus_5_secondary: {DEFAULT: '#8b8c90'},
	onsior: {DEFAULT: '#00a9ce'},
	onsior_cool_gray_10: {DEFAULT: '#63666a'},
	onsior_tangerine: {DEFAULT: '#ffb81c'},
	onsior_dark_gray: {DEFAULT: '#2c2a29'},
	onsior_cool_gray_6c: {DEFAULT: '#a7a8aa'},
	onsior_dark_red: {DEFAULT: '#9d2235'},
	onsior_vivid_orange: {DEFAULT: '#ff671f'},
	onsior_dark_violet: {DEFAULT: '#3c1053'},
	onsior_lime_green: {DEFAULT: '#00b140'},
	onsior_dark_blue: {DEFAULT: '#003594'},
	onsior_rhodamine_red: {DEFAULT: '#e10098'},
	onsior_advantix_light: {DEFAULT: '#f9e5eb'},
	agita_10wg: {DEFAULT: '#7ea0c4'},
	baseline: {DEFAULT: '#db3168'},
	baytril_100: {DEFAULT: '#008f87'},
	evosure: {DEFAULT: '#e56606'},
	feedaid: {DEFAULT: '#729786'},
	full_value_pork_primary_blue: {DEFAULT: '#004267'},
	full_value_pork_secondary_blue: {DEFAULT: '#30a9d7'},
	lipinate: {DEFAULT: '#464c3e'},
	pili_shield_plus_c: {DEFAULT: '#7f2629'},
	proteck: {DEFAULT: '#cc9000'},
	rhini_shield: {DEFAULT: '#009383'},
	swine_awake: {DEFAULT: '#7b2379'},
	tempo_one_percent_dust: {DEFAULT: '#75bc43'},
	light_gray: {DEFAULT: '#f2f2f2'},
	credelio_quattro_guard_dog: {DEFAULT: '#0F3320'},
	credelio_quattro_hunter_green: {DEFAULT: '#00643C'},
	credelio_quattro_grass_green: {DEFAULT: '#009548'},
	credelio_quattro_tennis_ball_green: {DEFAULT: '#80BB4F'},
	credelio_quattro_park_green: {DEFAULT: '#94CE95'},
	credelio_quattro_milk_bone: {DEFAULT: '#EDECDE'},
	credelio_quattro_golden: {DEFAULT: '#F68A33'},
	credelio_quattro_frisbee: {DEFAULT: '#EC008C'},
	credelio_quattro_sunny_day: {DEFAULT: '#EAAC18'},
	credelio_quattro_sky_blue: {DEFAULT: '#0099D8'},
	pet_protect_red: {DEFAULT: '#F9423A'},
	pet_protect_green: {DEFAULT: '#13863D'},
	pet_protect_blue: {DEFAULT: '#49B2E6'},
	clean_up_2: {DEFAULT: '#92C050'},
	cydectin: {DEFAULT: '#5C4586'},
	micotil: {DEFAULT: '#13B5EA'},
	scour_bos: {DEFAULT: '#6A2875'},
	vira_shield: {DEFAULT: '#E05A28'},
	pet_protect_skin: {DEFAULT: '#25B0E7'},
	pet_protect_calm: {DEFAULT: '#C05694'},
	pet_protect_allergy: {DEFAULT: '#70B925'},
	civ: {DEFAULT: '#CFB62E'},
	elmaro_navy_blue: {DEFAULT: '#00457f'},
	elmaro_pink: {DEFAULT: '#eb7bae'},
	elmaro_yellow: {DEFAULT: '#fbba00'},
	rosa_xo_verme: {DEFAULT: '#e82e8a'},
	catosal_metabol: {DEFAULT: '#FF3399'},
	pet: {DEFAULT: '#2B9E3B'},
	vet: {DEFAULT: '#3818A2'},
	'default-light-background': {DEFAULT: '#d5c4af'},

	// Brand colors
	'elanco-green': {DEFAULT: '#0EC3A4'},
	'pet-green-light': {DEFAULT: '#CAE3C8'},
	'pet-green': {DEFAULT: '#1F8815'},
	'purple-light': {DEFAULT: '#EAE6F5'},
	'vet-purple': {DEFAULT: '#3818A2'},
}
